// src/components/modal/tabs/NutritionTabContent.tsx
import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import type { MenuItem, Branch } from "~/types/new_types";

interface NutritionTabContentProps {
  item: MenuItem;
  theme:
    | Branch["theme"]
    | {
        primaryColor?: string;
        secondaryColor?: string;
        backgroundColor?: string;
        cardColor?: string;
        textColor?: string;
        borderColor?: string;
        borderRadius?: string;
        fontFamily?: string;
      };
  language: string;
}

export const NutritionTabContent: React.FC<NutritionTabContentProps> = ({
  item,
  theme,
  language,
}) => {
  const { t } = useTranslation();

  return (
    <motion.div key="nutrition">
      {item.calories ? (
        <div>
          <h3 className="font-bold mb-4" style={{ color: theme?.textColor }}>
            {t("menu.nutritionalInfo")}
          </h3>

          <div
            className="p-6 rounded-lg flex items-center gap-4"
            style={{
              backgroundColor: `${theme?.primaryColor}10`,
              borderRadius: theme?.borderRadius,
            }}
          >
            <div
              className="w-16 h-16 rounded-full flex items-center justify-center text-center font-bold text-xl"
              style={{
                backgroundColor: `${theme?.primaryColor}20`,
                color: theme?.primaryColor,
              }}
            >
              {item.calories}
            </div>
            <div>
              <div className="font-medium" style={{ color: theme?.textColor }}>
                {t("menuItem.calories")}
              </div>
              <div
                className="text-sm"
                style={{ color: `${theme?.textColor}70` }}
              >
                {t("menuItem.calorieUnit")}
              </div>
            </div>
          </div>

          {/* Additional nutritional info could be added here */}
        </div>
      ) : (
        <div
          className="flex flex-col items-center justify-center py-8 text-center"
          style={{ color: `${theme?.textColor}60` }}
        >
          <div className="text-4xl mb-4">🔍</div>
          <p>{t("menuItem.noNutritionals")}</p>
        </div>
      )}
    </motion.div>
  );
};
